module.exports = __webpack_public_path__ + "static/media/quote-doerr-feedback-fr.3beb3cd9.png";